<template>
    <Head>
        <title>Product Distributors | NutriStudents K-12</title>
        <meta name="description" content="Product Distributors" />
    </Head>
    <default-layout>
        <BreadcrumLayout />

        <PageTitleLayout>
            <div class="lg:mb-0 mb-4 w-1/2">
                <h1 class="heading-color xl:text-4xl text-2xl font-bold">
                    Distributor Products  ({{ activeDistributorName }})
                </h1>
            </div>
            <div
                class="w-full flex lg:flex-nowrap flex-wrap justify-end items-center"
            >
                <select name="distributor" v-model="activeDistributor">
                    <option :value="id" v-for="(name, id) in distributor_list">
                        {{ name }}
                    </option>
                </select>
                <!-- <button>
                <inertia-link :href="route('add-product-distributor')" class="button-color text-white font-bold py-3 xl:px-4 px-2 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 mt-10  inline-block">
                    CREATE NEW DISTRIBUTOR
                </inertia-link>
            </button> -->
            </div>
        </PageTitleLayout>

        <!-- <TableFilterLayout @messageFromChild="distributorSearchData" /> -->

        <TableIndexLayout>
            <div class="-my-2">
                <div
                    class="py-2 align-middle inline-block xl:px-10 px-5 w-full"
                >
                    <div class="shadow overflow-x-auto">
                        <table class="min-w-full">
                            <thead class="header-bg-color">
                                <tr>
                                    <th
                                        scope="col"
                                        class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                    >
                                        ACTIONS
                                    </th>
                                    <!-- <th
                                        scope="col"
                                        class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                    >
                                        Distributor Name
                                    </th> -->

                                    <th
                                        scope="col"
                                        class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                    >
                                        DISTRIBUTOR NUMBER
                                    </th>

                                    <th
                                        scope="col"
                                        class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                    >
                                        PACK
                                    </th>

                                    <th
                                        scope="col"
                                        class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                    >
                                        SIZE
                                    </th>



                                    <th
                                        scope="col"
                                        class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                    >
                                        CASE QTY
                                    </th>

                                    <th
                                        scope="col"
                                        class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                    >
                                        CASE WEIGHT
                                    </th>
                                    <th
                                        scope="col"
                                        class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                    >
                                        SUB CASE WEIGHT
                                    </th>
                                    <th
                                        scope="col"
                                        class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                    >
                                        CASE VOLUME
                                    </th>
                                    <th
                                        scope="col"
                                        class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                    >
                                        SUB CASE VOLUME
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-if="!distributors.length"
                                    class="bg-white"
                                >
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-base text-color text-center"
                                        colspan="13"
                                    >
                                        No Distributor Found
                                    </td>
                                </tr>

                                <!-- Odd row -->
                                <tr
                                    v-for="(distributor, index) in distributors"
                                    :class="{
                                        'bg-white': index % 2 == 0,
                                        'tr-background-color': index % 2 != 0,
                                    }"
                                >
                                    <td
                                        class="px-6 py-4 whitespace-nowrap id-color text-xl font-extrabold"
                                    >
                                        <!-- <button v-if="distributor.products.length === 0" title="No Products"><i class="fa fa-exclamation-triangle pr-3" aria-hidden="true"></i></button> -->



                                        <button v-if="distributor.products.length === 0" title="No Products"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1600 1600" width="25" height="25">
                                            <path transform="translate(896 149)" d="m0 0c17 15.8 28.8 35 40.3 55 3.09 5.33 6.31 10.6 9.55 15.8 3.32 5.39 6.62 10.8 9.91 16.2 0.356 0.586 0.712 1.17 1.08 1.78 6.43 10.6 12.8 21.2 19.1 31.9 5.46 9.23 11 18.4 16.7 27.5 3.52 5.65 6.92 11.3 10.3 17.1 4.01 6.86 8.13 13.6 12.3 20.4 5.47 8.98 10.9 18 16.3 27 5.24 8.75 10.5 17.5 15.8 26.2 6.03 9.92 12 19.9 18 29.8 0.382 0.637 0.764 1.27 1.16 1.93 3.58 5.97 7.16 11.9 10.7 17.9 6.03 10.1 12.1 20.1 18.2 30.1 7.58 12.5 15.1 25 22.6 37.5 10.4 17.4 10.4 17.4 21 34.7 5.22 8.51 10.3 17.1 15.4 25.7 6.75 11.3 13.5 22.5 20.4 33.8 4.59 7.55 9.16 15.1 13.7 22.7 3.57 5.96 7.19 11.9 10.8 17.8 6.41 10.5 12.8 21.1 19.1 31.7 3.02 5.04 6.04 10.1 9.06 15.1 7.13 11.9 7.13 11.9 10.5 17.6 6.22 10.4 12.5 20.8 18.8 31.1 4.6 7.57 9.18 15.1 13.7 22.7 2.02 3.37 4.06 6.73 6.11 10.1 1.41 2.31 2.82 4.63 4.23 6.94 0.36 0.592 0.721 1.18 1.09 1.79 6 9.86 11.9 19.8 17.8 29.7 5.65 9.55 11.4 19.1 17.3 28.5 5.43 8.72 10.6 17.6 15.9 26.4 5.54 9.35 11.1 18.7 16.8 27.9 2.17 3.53 4.31 7.08 6.44 10.6 2.83 4.73 5.68 9.45 8.55 14.2 7.83 12.9 15.6 25.8 23.3 38.7 4.95 8.37 9.91 16.7 15.1 24.9 5.52 8.75 10.7 17.7 16 26.6 4.32 7.31 8.69 14.6 13.2 21.8 2.45 3.96 4.84 7.96 7.22 12 4.99 8.33 10 16.6 15.1 24.9 7.25 11.9 14.4 23.9 21.6 35.8 5.3 8.87 10.7 17.7 16 26.5 7.43 12.2 14.8 24.5 22.2 36.8 3.12 5.2 6.24 10.4 9.36 15.6 2.5 4.16 4.99 8.32 7.48 12.5 0.784 1.31 0.784 1.31 1.58 2.64 0.977 1.63 1.95 3.26 2.93 4.9 3.38 5.65 6.83 11.3 10.3 16.9 5.65 9.18 11.2 18.4 16.8 27.6 1.48 2.45 2.97 4.9 4.45 7.35 24.6 40.6 39.9 79.8 28.5 128-6.57 26.3-18.7 47.9-37.3 67.4-1.16 1.21-2.29 2.45-3.42 3.68-21.8 23.2-57.9 37.6-89.3 38.8-2.46 0.0354-4.91 0.0409-7.37 0.0344-0.938 0.00153-1.88 0.00305-2.84 0.00463-3.14 0.0039-6.29 6.85e-4 -9.43-0.00249-2.29 0.00135-4.57 0.00313-6.86 0.00531-6.31 0.00474-12.6 0.00323-18.9 7.22e-4 -6.14-0.00195-12.3 0.00178-18.4 0.00487-12.7 0.00623-25.4 0.00771-38.2 0.00658-12.9-0.00112-25.8-9.12e-5 -38.7 0.00357-0.814 2.3e-4 -1.63 4.59e-4 -2.47 6.96e-4 -3.32 9.42e-4 -6.63 0.0019-9.95 0.00287-34.6 0.0101-69.2 0.0132-104 0.0138-3.72 6.47e-5 -7.45 1.33e-4 -11.2 2.03e-4 -0.924 1.7e-5 -1.85 3.4e-5 -2.8 5.15e-5 -20.5 4.08e-4 -41 0.0026-61.4 0.0051-8.43 0.00103-16.9 0.00202-25.3 0.00302-1.4 1.66e-4 -1.4 1.66e-4 -2.82 3.35e-4 -53.4 0.00632-107 0.0104-160 0.00999-2-1.58e-5 -4-3.15e-5 -5.99-4.72e-5 -9.02-7.34e-5 -18-1.62e-4 -27.1-2.54e-4 -4.02-4.11e-5 -8.05-8.13e-5 -12.1-1.21e-4 -2.01-2.04e-5 -4.03-4.14e-5 -6.04-6.31e-5 -63.7-6.8e-4 -127 0.00664-191 0.0205-16 0.0035-32.1 0.00697-48.1 0.0103-1.48 3.04e-4 -1.48 3.04e-4 -2.99 6.15e-4 -30.4 0.00621-60.9 0.00998-91.3 0.0112-0.956 4e-5 -1.91 7.99e-5 -2.9 1.21e-4 -21 8.53e-4 -42 0.00111-62.9 8.3e-4 -7.51-9.65e-5 -15-1.49e-4 -22.5-1.79e-4 -1.87-7.91e-6 -3.74-1.81e-5 -5.6-3.06e-5 -29.8-1.76e-4 -59.5 0.00552-89.3 0.0142-30 0.00865-60 0.0108-89.9 0.00424-4.14-9.12e-4 -8.29-0.00176-12.4-0.00256-1.22-2.4e-4 -1.22-2.4e-4 -2.46-4.85e-4 -12.9-0.00235-25.7 2e-3 -38.6 0.00916-12.6 0.00689-25.3 0.00664-37.9-0.00119-6.76-4e-3 -13.5-0.00462-20.3 0.00346-6.15 0.00728-12.3 0.00534-18.5-0.00392-2.21-0.00172-4.42-9.89e-5 -6.63 0.0053-15.1 0.0343-29.5-0.515-44.1-4.57-0.804-0.22-1.61-0.44-2.44-0.667-24.3-6.81-43.8-19.8-61.9-37l-2.03-1.9c-25.3-24.3-39.3-61.1-40.5-95.8-0.562-38 15.6-69.6 35.3-101 3.27-5.24 6.43-10.6 9.55-15.9 5.03-8.57 10.1-17.1 15.3-25.6 0.548-0.901 0.548-0.901 1.11-1.82 0.546-0.897 0.546-0.897 1.1-1.81 0.723-1.19 1.45-2.38 2.17-3.56 0.528-0.868 0.528-0.868 1.07-1.75 3.02-4.96 6.01-9.94 8.99-14.9 4.3-7.18 8.64-14.3 13-21.5 7.56-12.4 15-24.9 22.4-37.4 4.15-7.02 8.36-14 12.6-20.9 3.28-5.31 6.52-10.6 9.76-16 0.355-0.584 0.71-1.17 1.08-1.77 6.5-10.7 12.9-21.5 19.3-32.3 4.69-7.92 9.41-15.8 14.3-23.6 3.94-6.24 7.66-12.6 11.4-19 4.57-7.77 9.24-15.5 13.9-23.2 3.68-6.03 7.34-12.1 11-18.1 4.74-7.92 9.52-15.8 14.3-23.7 9.4-15.5 18.7-31 28-46.5 5.34-8.92 10.7-17.8 16.1-26.7 5.23-8.59 10.4-17.2 15.5-25.9 4.67-7.96 9.48-15.8 14.4-23.7 4.57-7.35 8.98-14.8 13.4-22.2 3.42-5.81 6.9-11.6 10.5-17.3 2.64-4.29 5.23-8.61 7.82-12.9 0.512-0.854 1.02-1.71 1.55-2.59 2.06-3.44 4.12-6.89 6.18-10.3 6.39-10.7 12.8-21.3 19.3-32 4.19-6.87 8.33-13.8 12.5-20.7 3.94-6.57 7.92-13.1 11.9-19.7 0.359-0.59 0.718-1.18 1.09-1.79 0.359-0.591 0.719-1.18 1.09-1.79 5.37-8.82 10.7-17.7 15.9-26.6 5.24-8.88 10.6-17.7 16-26.4 4.97-7.99 9.75-16.1 14.5-24.2 3.15-5.35 6.32-10.7 9.52-16 0.455-0.76 0.91-1.52 1.38-2.3 3.37-5.62 6.81-11.2 10.2-16.8 3.31-5.38 6.6-10.8 9.88-16.2 0.356-0.586 0.712-1.17 1.08-1.78 6.44-10.6 12.8-21.2 19.1-31.9 5.39-9.11 10.9-18.2 16.5-27.1 4.25-6.82 8.34-13.7 12.4-20.7 4.44-7.55 8.97-15 13.5-22.5 8.72-14.3 17.4-28.7 26-43.1 5.33-8.9 10.7-17.8 16.1-26.6 5.02-8.26 10-16.5 15-24.8 3.83-6.39 7.7-12.8 11.6-19.1 0.355-0.582 0.709-1.16 1.07-1.76 0.354-0.581 0.708-1.16 1.07-1.76 6.43-10.6 12.7-21.2 19-31.8 4.68-7.91 9.4-15.8 14.3-23.6 4-6.32 7.74-12.8 11.5-19.2 4.17-7.07 8.48-14 12.9-20.9 2.76-4.31 5.33-8.67 7.79-13.2 2.16-3.9 4.46-7.71 6.76-11.5 0.514-0.853 1.03-1.71 1.56-2.59 1.64-2.72 3.29-5.44 4.94-8.16 0.83-1.37 0.83-1.37 1.68-2.78 9.96-16.4 20.3-31.9 34.3-45.2 0.988-0.963 0.988-0.963 2-1.95 52.7-49.7 139-48 192-0.251zm-128 82.8c-3.32 4.28-5.99 8.93-8.71 13.6-1.32 2.23-2.63 4.46-3.95 6.68-0.508 0.862-0.508 0.862-1.03 1.74-3.53 5.98-7.13 11.9-10.7 17.9-7.19 11.8-14.3 23.6-21.4 35.5-8.22 13.7-16.5 27.4-24.8 41.1-4.9 8.06-9.78 16.1-14.6 24.2-4.34 7.24-8.71 14.4-13.1 21.7-6.87 11.3-13.7 22.6-20.5 34-7.16 12-14.4 23.9-21.6 35.8-6.5 10.7-13 21.4-19.4 32.2-7.16 12-14.4 23.9-21.6 35.8-4.96 8.16-9.9 16.3-14.8 24.5-3.83 6.39-7.7 12.8-11.6 19.1-0.533 0.875-0.533 0.875-1.08 1.77-0.356 0.585-0.712 1.17-1.08 1.77-6.29 10.3-12.5 20.7-18.6 31.1-6.02 10.2-12.2 20.3-18.4 30.3-4.68 7.58-9.26 15.2-13.8 22.9-5.44 9.22-10.9 18.4-16.5 27.6-0.353 0.58-0.706 1.16-1.07 1.76-2.85 4.68-5.69 9.35-8.54 14-2.44 4.01-4.88 8.02-7.32 12-0.517 0.85-0.517 0.85-1.05 1.72-6.33 10.4-12.5 20.9-18.7 31.4-4.76 8.04-9.55 16-14.6 23.9-2.7 4.28-5.29 8.61-7.84 13-4.45 7.64-9.03 15.2-13.6 22.8-5.51 9.05-11 18.1-16.4 27.2-0.918 1.53-0.918 1.53-1.85 3.09-1.84 3.07-3.68 6.15-5.52 9.22-8.22 13.7-16.5 27.4-24.8 41.1-4.91 8.07-9.79 16.2-14.6 24.3-3.83 6.39-7.7 12.8-11.6 19.1-0.355 0.582-0.709 1.16-1.07 1.76-0.354 0.581-0.708 1.16-1.07 1.76-6.43 10.6-12.7 21.2-19 31.8-4.54 7.67-9.11 15.3-13.9 22.8-5.08 8.04-9.85 16.3-14.7 24.5-4.89 8.27-9.81 16.5-15 24.6-3.13 4.95-6.09 9.98-9.04 15-4.19 7.16-8.49 14.2-12.8 21.3-0.559 0.919-0.559 0.919-1.13 1.86-0.742 1.22-1.48 2.44-2.23 3.66-0.358 0.589-0.717 1.18-1.09 1.79-0.353 0.58-0.706 1.16-1.07 1.76-4.01 6.59-7.97 13.2-11.9 19.8-1.44 2.4-2.87 4.79-4.31 7.19-2.44 4.07-4.89 8.14-7.32 12.2-6.29 10.5-12.6 21-19 31.4-4.96 8.16-9.9 16.3-14.8 24.5-3.83 6.39-7.7 12.8-11.6 19.1-0.355 0.583-0.71 1.17-1.08 1.77-0.355 0.583-0.71 1.17-1.08 1.77-6.36 10.5-12.6 21-18.8 31.5-5.24 8.86-10.6 17.7-16 26.4-5.46 8.76-10.7 17.6-15.9 26.5-4.52 7.66-9.07 15.3-13.9 22.8-8.34 13.1-13.7 25.3-10.5 41.1 3.39 11.3 10.8 20.4 21.2 26 7.35 3.33 14.7 4.05 22.7 4 0.928 0.00293 1.86 0.00586 2.81 0.00888 3.11 0.00738 6.22 5.29e-4 9.33-0.00625 2.26 0.00239 4.52 0.00566 6.79 0.00972 6.24 0.00864 12.5 0.00478 18.7-0.00106 6.08-0.00373 12.2 0.00195 18.2 0.00735 12.6 0.0108 25.2 0.0122 37.8 0.0083 12.8-0.00388 25.5-0.00342 38.3 0.00231 0.805 3.59e-4 1.61 7.18e-4 2.44 0.00109 3.28 0.00147 6.56 0.00298 9.84 0.00452 33.3 0.0156 66.6 0.0183 99.9 0.0158 4.6-3.38e-4 9.21-6.61e-4 13.8-9.66e-4 0.914-6.1e-5 1.83-1.22e-4 2.77-1.85e-4 20.3-0.00127 40.5 0.00133 60.8 0.00471 4.62 7.71e-4 9.25 0.00152 13.9 0.00227 1.86 3.02e-4 3.71 6.04e-4 5.57 9.06e-4 0.92 1.5e-4 1.84 2.99e-4 2.79 4.54e-4 1.86 3.04e-4 3.72 6.08e-4 5.58 9.14e-4 52.8 0.00867 106 0.0133 158 0.00905 0.978-7.81e-5 1.96-1.56e-4 2.96-2.37e-4 10.9-8.73e-4 21.8-0.0018 32.7-0.00275 0.985-8.55e-5 1.97-1.71e-4 2.98-2.59e-4 5.97-5.19e-4 5.97-5.19e-4 11.9-0.00104 63-0.00554 126 0.00201 189 0.0208 15.9 0.00472 31.7 0.0094 47.6 0.0138 1.47 4.1e-4 1.47 4.1e-4 2.96 8.28e-4 30.1 0.00837 60.2 0.0131 90.3 0.0139 0.945 2.64e-5 1.89 5.27e-5 2.86 7.99e-5 20.7 5.41e-4 41.5 1.68e-4 62.2-0.00104 7.42-4.26e-4 14.8-7.91e-4 22.3-0.00113 1.85-8.53e-5 3.69-1.74e-4 5.54-2.67e-4 29.4-0.00145 58.9 0.00568 88.3 0.017 30.5 0.0116 60.9 0.0122 91.4 1.57e-4 3.27-0.00125 6.54-0.00246 9.81-0.00362 0.803-2.9e-4 1.61-5.81e-4 2.43-8.8e-4 12.7-0.00433 25.4 0.00141 38.2 0.0113 12.5 0.00953 25 0.00837 37.5-0.00421 6.69-0.00644 13.4-0.00778 20.1 0.00386 6.08 0.0105 12.2 0.00723 18.3-0.0071 2.19-0.00273 4.38-4.18e-4 6.57 0.00751 15.5 0.0523 29.6-0.202 41.8-11.2 8.07-8.63 12.6-19.6 12.3-31.4-1.3-11.9-7.25-21.7-13.3-31.7l-1.93-3.21c-4.02-6.67-8.07-13.3-12.1-20-2.63-4.31-5.23-8.62-7.82-13-3.11-5.21-6.27-10.4-9.44-15.6-6.44-10.5-12.8-21.1-19.1-31.7-6.69-11.2-13.4-22.3-20.2-33.4-4.96-8.16-9.9-16.3-14.8-24.5-3.89-6.49-7.81-13-11.7-19.4-0.36-0.592-0.72-1.18-1.09-1.79-0.36-0.591-0.72-1.18-1.09-1.79-5.37-8.82-10.7-17.7-15.9-26.6-4.6-7.8-9.26-15.6-14.1-23.2-6.01-9.61-11.8-19.4-17.6-29.1-5.06-8.55-10.1-17.1-15.3-25.5-3.17-5.16-6.29-10.3-9.4-15.5-4.86-8.12-9.77-16.2-14.7-24.3-8.47-13.9-16.9-27.9-25.2-41.9-6.72-11.2-13.5-22.4-20.3-33.6-5.43-8.93-10.8-17.9-16.2-26.8-6.73-11.3-13.5-22.5-20.3-33.7-8.57-14.1-17.1-28.2-25.5-42.4-7.61-12.7-15.3-25.4-23-38.1-4.9-8.06-9.77-16.1-14.6-24.2-4.77-7.97-9.6-15.9-14.4-23.8-4.59-7.55-9.16-15.1-13.7-22.7-2.45-4.09-4.93-8.16-7.41-12.2-6.85-11.3-13.7-22.5-20.3-33.9-4.46-7.57-9.01-15.1-13.6-22.6-3.68-6.03-7.34-12.1-11-18.1-4.36-7.29-8.76-14.5-13.2-21.8-0.354-0.581-0.707-1.16-1.07-1.76-0.354-0.581-0.707-1.16-1.07-1.76-6.43-10.6-12.7-21.2-19-31.8-6.3-10.6-6.3-10.6-12.8-21.2-4.86-7.65-9.45-15.5-14.1-23.2-6.13-10.4-12.3-20.7-18.6-31-0.521-0.856-0.521-0.856-1.05-1.73-2.44-4.01-4.88-8.01-7.32-12-2.79-4.58-5.59-9.16-8.38-13.8-0.345-0.567-0.691-1.13-1.05-1.72-6.33-10.4-12.5-20.9-18.8-31.4-4.69-7.92-9.41-15.8-14.3-23.6-3.94-6.24-7.66-12.6-11.4-19-3.99-6.79-8.06-13.5-12.2-20.3-6.84-11.2-13.6-22.5-20.3-33.7-6.76-11.3-13.6-22.6-20.4-33.8-4.59-7.54-9.15-15.1-13.7-22.7-2.15-3.59-4.33-7.17-6.5-10.8-0.363-0.598-0.727-1.2-1.1-1.81-1.88-3.1-3.77-6.21-5.66-9.31-6.16-10.1-6.16-10.1-9.05-15.1-6.9-11.9-14.4-22.3-27.8-27.1-17.5-4.54-33 1.06-44.5 14.5z"/>
                                            <path transform="translate(853 559)" d="m0 0c9.13 8.53 15.9 21.2 16.3 33.8 0.0405 2.97 0.0464 5.93 0.0407 8.89 9.57e-4 1.13 0.00191 2.26 0.0029 3.42 6.81e-4 2.42-0.00117 4.83-0.00534 7.25-0.00516 3.52-1.56e-4 7.04 0.00635 10.6 0.0195 42.4-1.77 84.7-3.71 127-0.331 7.22-0.656 14.4-0.981 21.6-0.549 12.2-1.1 24.4-1.65 36.6-0.0484 1.06-0.0484 1.06-0.0978 2.15-0.461 10.1-0.934 20.2-1.41 30.3-1.47 31-2.75 61.9-3.35 92.9-0.154 7.87-0.325 15.7-0.495 23.6-0.0175 0.819-0.0351 1.64-0.0531 2.48-1.1 50.8-1.1 50.8-13.3 62.9-14.1 11.8-34.9 15.9-52.8 14.4-14.1-1.45-28.3-4.62-38.2-15.5-11.1-13.8-10.2-30.4-10.5-47.5-0.0674-4.17-0.15-8.34-0.23-12.5-0.0167-0.889-0.0334-1.78-0.0507-2.69-0.676-35.8-1.84-71.6-3.47-107-0.0479-1.05-0.0959-2.11-0.145-3.19-0.688-15.1-1.39-30.2-2.11-45.3-0.866-18.4-1.72-36.7-2.56-55.1-0.0716-1.57-0.0716-1.57-0.145-3.17-1.41-31-2.51-61.9-3.23-92.9-0.0204-0.874-0.0407-1.75-0.0617-2.65-0.694-30-0.694-30-0.772-45-0.00675-0.697-0.0135-1.39-0.0205-2.11 0.00478-16.6 5.23-31 17.1-42.9 27.7-26.1 77.5-23.2 106-0.137z"/>
                                            <path transform="translate(843 1118)" d="m0 0c1.24 1.01 2.47 2.03 3.69 3.06 0.714 0.559 1.43 1.12 2.16 1.7 13.5 11.1 22.2 28.1 24.8 45.3 2 20.5-2.59 40.3-15.7 56.5-12.8 14.8-29.6 25.3-49.3 27.5-22.2 0.99-40.6-3.96-57.7-18.8-14.6-13.7-23.2-32-24.4-52.1-0.524-20.1 7.21-39.2 20.3-54.3 25-25.9 66.8-30.2 96.1-8.92z"/>
                                        </svg></button>


                                        <button v-show="distributor.products.length > 0"
                                            @click="showProduct(distributor)"
                                            title="Show Products"
                                        >
                                            <i
                                                class="fa fa-eye pr-3"
                                                aria-hidden="true"
                                            ></i>
                                        </button>

                                    </td>



                                    <!-- <td
                                        class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                    >
                                        {{ distributor.distributor.name }}
                                    </td> -->
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                    >
                                        {{ distributor.item_number }}
                                    </td>
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                    >
                                        {{ distributor.pack }}
                                    </td>
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                    >
                                        {{ distributor.size }}
                                    </td>

                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                    >
                                        {{ distributor.case_qty }}
                                    </td>
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                    >
                                        {{ formattedNumber(Number(distributor.case_weight)) }} {{ distributor.case_weight_uom }}
                                    </td>
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                    >
                                        {{ formattedNumber(Number(distributor.sub_case_weight)) }} {{ distributor.sub_case_weight_uom }}
                                    </td>
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                    >
                                        {{ formattedNumber(Number(distributor.case_volume)) }} {{ distributor.case_volume_uom }}
                                    </td>
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                    >
                                        {{ formattedNumber(Number(distributor.sub_case_volume)) }} {{ distributor.sub_case_volume_uom }}
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="mt-12 flex justify-end pr-10 w-full mb-8">
                <div class="float-left w-full flex justify-start px-10">
                    <paginate :urlsArray="links"></paginate>
                </div>
                <!-- <button>
                <inertia-link :href="route('add-product-distributor')" class="button-color text-white font-bold py-1.5 px-4 mb- rounded focus:outline-none  inline-block">
                    CREATE NEW DISTRIBUTOR
                </inertia-link>
            </button> -->
            </div>
        </TableIndexLayout>
    </default-layout>

    <jet-dialog-modal :show="showProductModal" maxWidth="4xl">
        <template #title>
            <div class="flex justify-between items-center text-3xl mt-5 mb-4">
                Products
            </div>
        </template>

        <template #content>
            <TableIndexLayout>
                <div class="-my-2">
                    <div class="py-2 align-middle inline-block w-full">
                        <div class="shadow overflow-x-auto">
                            <table class="min-w-full">
                                <thead class="header-bg-color">
                                    <tr>
                                        <th
                                            scope="col"
                                            class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                        >
                                            Product Name
                                        </th>

                                        <th
                                            scope="col"
                                            class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                        >
                                            Manufacturer
                                        </th>
                                        <th
                                            scope="col"
                                            class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                        >
                                            CN Code
                                        </th>
                                        <th
                                            scope="col"
                                            class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                        >
                                            Gtin
                                        </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-if="products.length == 0"
                                        class="bg-white"
                                    >
                                        <td
                                            class="px-6 py-4 whitespace-nowrap text-base text-color text-center"
                                            colspan="13"
                                        >
                                            No Product
                                        </td>
                                    </tr>

                                    <tr
                                        v-for="(product, index) in products"
                                        :class="{
                                            'bg-white': index % 2 == 0,
                                            'tr-background-color':
                                                index % 2 != 0,
                                        }"
                                    >
                                        <td
                                            class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color underline id-color font-bold"
                                        >
                                            <div class="tooltip">
                                                <div
                                                    class="trim_text underline"
                                                >
                                                    <a
                                                        target="_blank"
                                                        :href="
                                                            route(
                                                                'products_edit',
                                                                {
                                                                    id: product.id,
                                                                }
                                                            )
                                                        "
                                                        >{{ product.name }}</a
                                                    >
                                                </div>
                                            </div>
                                        </td>
                                        <td
                                            class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                        >
                                            {{ product.manufacturer || "N/A" }}
                                        </td>
                                        <td
                                            class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                        >
                                            {{ product.cn_code || "N/A" }}
                                        </td>
                                        <td
                                            class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                        >
                                            {{ product.gtin || "N/A" }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </TableIndexLayout>
        </template>

        <template #footer>
            <jet-secondary-button
                @click="showProductModal = false"
                class="ml-4 text-lg"
                >Close</jet-secondary-button
            >
        </template>
    </jet-dialog-modal>
</template>

<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import Welcome from "@/Jetstream/Welcome";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import JetDialogModal from "@/Jetstream/DialogModal";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import Paginate from "@/Pages/Partials/Paginate";

export default {
    props: ["all_distributors", "distributor_list", "active_distributor"],
    components: {
        DefaultLayout,
        Welcome,
        BreadcrumLayout,
        PageTitleLayout,
        TableFilterLayout,
        TableIndexLayout,
        JetDialogModal,
        JetSecondaryButton,
        Paginate,
    },
    data() {
        return {
            distributors: this.all_distributors
                ? this.all_distributors.data
                : [],
            form: this.$inertia.form({
                file: "",
                distributor_id: "",
            }),
            importProductsModal: false,
            activeDistributor: this.active_distributor,
            links: this.all_distributors.links,
            showProductModal: false,
            products: [],
        };
    },
    watch: {
        activeDistributor(val) {
            if (val)
                window.location.href = `/product-distributor-products/${val}`;
        },


    },

    computed: {
        activeDistributorName() {
            console.log('active distributor name', this.distributor_list[this.activeDistributor]);
            return this.distributor_list[this.activeDistributor] || '';
        },
    },
    methods: {

        handleFileUpload(e) {
            const file = event.target.files[0];
            console.log(file);
            if (file) {
                this.form.file = file;
            }
        },

        formattedNumber(value) {
            return value.toLocaleString(); // Format number with commas
        },

        formatAsCurrency(value) {
        // Format the number as currency with dollar symbol
            return value.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            });
        },

        // onChangeFile(){

        // },

        // onProuductsyncImport(e) {
        // let img_file = e.target.files || e.dataTransfer.files;
        //     if (!img_file.length) {
        //         return;
        //     } else {
        //         // this.uploadProgress = true;
        //         let $this = this;
        //         Vapor.store(e.target.files[0], {
        //         // visibility: 'public-read',
        //         progress: (progress) => {},
        //         }).then((response) => {
        //         // $this.uploadProgress = false;
        //         $this.form.file = response;
        //         console.log("vapor response", response);
        //         });
        //     }
        // },

        openImportProductModal(index) {
            console.log("Distributor_id", this.distributors[index].id);
            this.form.distributor_id = this.distributors[index].id;
            // this.distributor_id = this.distributors[index];
            this.importProductsModal = true;
        },

        importProducts() {
            // let formData = new FormData();
            // formData.append('files_upload', this.files);

            this.form.post(this.route("import-distributor-products"), {
                onSuccess: () => {
                    // this.form.file='',
                    // console.log(this.form.file),
                    this.importProductsModal = false;
                    this.$refs.form_1.reset();
                    this.$toast.success("Excel Import Added Successfully!");
                },
            });

            // console.log('yess');
        },

        distributor_delete_script(distributorid) {
            if (confirm("Are you sure you want to delete this distributor?")) {
                this.form.post(
                    this.route("delete-product-distributor", distributorid),
                    {
                        onSuccess: () => {
                            this.$toast.success(
                                "Distributor deleted successfully!"
                            );
                            setTimeout(function () {
                                window.location.reload();
                            }, 1000);
                        },
                    }
                );
            }
        },

        distributorSearchData(search) {
            console.log("search", search);
            if (search == "") {
                this.distributors = this.all_distributors;
                // this.$toast.error('Error: Search value required!');
                // return false;
            } else {
                axios
                    .post("/search-product-distributor", {
                        term: search,
                    })
                    .then((response) => {
                        this.distributors = response.data;
                    })
                    .catch((error) => console.error(error));
            }
        },

        showProduct(data) {
            console.log("data", data);
            this.products = data.products;
            this.showProductModal = !this.showProductModal;
        },
    },
};
</script>

<style>
.id_arrow .fa-sort-desc:before {
    content: "\f0dd";
    position: absolute;
    top: 17px;
    left: 43px;
    padding-left: 7px;
    color: #219fd5;
}

.id_arrow .fa-sort-asc:before {
    content: "\f0de";
    color: #219fd5;
    padding-left: 7px;
    position: absolute;
    top: 17px;
    left: 43px;
}
</style>
